import React from 'react';
import { Trash2Icon, CheckIcon } from 'lucide-react';
import { useContent } from '../../ContentContext';
export function RequestManager() {
  const {
    requests,
    updateRequest,
    deleteRequest
  } = useContent();
  return <div data-id="element-176" data-mp="wwiqiqn0wag5">
      <h1 className="font-display text-3xl font-medium text-gray-900" data-id="element-177" data-mp="wwabas3fgt1s">Förfrågningar</h1>
      <p className="mt-2 text-sm text-gray-500" data-id="element-178" data-mp="rxz1uih1okk3">Alla beställningsförfrågningar som skickas via checkout landar här.</p>

      {requests.length === 0 ? <div className="mt-10 rounded-3xl border-2 border-dashed border-gray-200 p-16 text-center text-sm text-gray-400" data-id="element-179" data-mp="i8xl2q2odz52">
          Inga förfrågningar än.
        </div> : <div className="mt-10 space-y-5" data-id="element-180" data-mp="d7i2d4nz04pu">
          {requests.map(request => <article key={request.id} className="rounded-3xl bg-white p-8 shadow-premium" data-id="element-181" data-mp="9a3txf8460yw">
              <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-182" data-mp="48mt1jpmqeib">
                <div data-id="element-183" data-mp="3vgsconifuvak">
                  <div className="flex items-center gap-3" data-id="element-184" data-mp="3vg94hyilbl9q">
                    <h2 className="font-display text-xl font-medium text-gray-900" data-id="element-185" data-mp="36w0840epodls">{request.name || 'Namnlös förfrågan'}</h2>
                    <span className={`rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider ${request.status === 'ny' ? 'bg-black text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-186" data-mp="3bojof54s9mua">
                      {request.status}
                    </span>
                  </div>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-187" data-mp="3um4eugn74th0">
                    {request.customerType === 'company' ? 'Företag' : 'Privat'} ·{' '}
                    {request.logistics === 'delivery' ? 'Leverans' : 'Upphämtning'} · {request.email || '—'}
                  </p>
                  <p className="mt-1 text-xs text-gray-400" data-id="element-188" data-mp="25769qk26eq9l">
                    {request.date || 'Inget datum'} · {request.guests || '—'} gäster · Inkom{' '}
                    {new Date(request.createdAt).toLocaleDateString('sv-SE')}
                  </p>
                </div>
                <div className="flex items-center gap-2" data-id="element-189" data-mp="1q5pozj3l2cg9">
                  <button onClick={() => updateRequest(request.id, {
              status: request.status === 'ny' ? 'hanterad' : 'ny'
            })} className="flex items-center gap-2 rounded-full bg-gray-100 px-4 py-2 text-xs font-medium text-gray-900 transition-colors hover:bg-gray-200" data-id="element-190" data-mp="1m3kwwoss9nvq">
                    <CheckIcon className="h-3.5 w-3.5" data-id="element-191" data-mp="12dsmwjpxqysc" />
                    {request.status === 'ny' ? 'Markera hanterad' : 'Markera ny'}
                  </button>
                  <button onClick={() => deleteRequest(request.id)} aria-label="Ta bort förfrågan" className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition-colors hover:bg-red-50 hover:text-red-600" data-id="element-192" data-mp="yejvhlidbczy">
                    <Trash2Icon className="h-4 w-4" data-id="element-193" data-mp="2vbo868d19s1q" />
                  </button>
                </div>
              </div>

              {request.notes && <p className="mt-5 rounded-2xl bg-gray-50 p-4 text-sm text-gray-600" data-id="element-194" data-mp="308oemkdsowtd">{request.notes}</p>}

              {request.items.length > 0 && <ul className="mt-5 divide-y divide-gray-100 border-t border-gray-100" data-id="element-195" data-mp="39zstzl7dujoq">
                  {request.items.map((item, i) => <li key={i} className="flex items-center justify-between py-3 text-sm" data-id="element-196" data-mp="2cdln24nlwf97" data-mpi={i}>
                      <span className="text-gray-900" data-id="element-197" data-mp="2hc6ebekvroli">
                        {item.name}
                        <span className="ml-2 text-xs text-gray-400" data-id="element-198" data-mp="2m9ey1jlog0ov">{item.businessName}</span>
                      </span>
                      <span className="text-gray-600" data-id="element-199" data-mp="2qdmopmbp3qpq">
                        {item.quantity} × {item.price} kr
                      </span>
                    </li>)}
                  <li className="flex items-center justify-between pt-4 text-sm font-medium text-gray-900" data-id="element-200" data-mp="5kj73zyf1tp2">
                    <span data-id="element-201" data-mp="45728a8hgzj5">Totalt</span>
                    <span data-id="element-202" data-mp="3vazuka9n9tlo">{request.total} kr</span>
                  </li>
                </ul>}
            </article>)}
        </div>}
    </div>;
}